import axios from 'axios';

const BASE_API = process.env.VUE_API_ROOT;

export default {
  getSalesOrderItems(products, backordered, kitProducts, prices) {
    const sortedSalesOrderItems = [];

    const topLevelItems = [];
    const subItems = [];

    // Iterate through SO items in products and consume relevant fields
    products.forEach((product) => {
      if (product.itemtype === 'Shipping') return;
      if (product.itemtype === 'Tax') return;

      const salesOrderItem = {
        status: this.getSalesOrderItemStatus(product),
        type: product.itemtype,
        product: product.productnum,
        description: product.description,
        qty: product.qtyToFulfill,
        shipItemId: product.shipitemid,
        unit: product.code,
        unitPrice: product.unitPrice * 100,
        unitCost: Number(product.unitCost) !== NaN ? product.unitCost * 100 : product.unitCost,
        totalCost: Number(product.totalCost) !== NaN ? product.totalCost * 100 : product.totalCost,
        kit: product.itemtype === 'Kit',
        taxable: product.taxableFlag,
        note: product.note,
        id: product.productId,
        soitemid: product.soitemid,
        topparentid: product.topparentid,
        active: product.activeFlag,
      };

      const boItem = backordered.find(item => item.num === product.productnum);
      if (boItem) {
        salesOrderItem.qty_backordered = boItem.qty
        salesOrderItem.status = boItem.name;
      }

      if (salesOrderItem.topparentid) {
        salesOrderItem.depth = 1;
        subItems.push(salesOrderItem);
      } else {
        salesOrderItem.depth = 0;
        topLevelItems.push(salesOrderItem)
      }
    });

    topLevelItems.reverse();
    topLevelItems.forEach( (li) => {
      sortedSalesOrderItems.push(li);
      const sis = subItems.filter( (e) => { return e.topparentid == li.soitemid } )
      sis.forEach( (si) =>{
        sortedSalesOrderItems.push(si);
      });
    });

    sortedSalesOrderItems.forEach(item => {
      if (item.active) {
        if (item.kit) {
          item.kititems = kitProducts.filter(row =>
            row.kitproductid === item.id
            && row.productid !== item.id);
        }
        if (item.topparentid) {
          item.kitItemPrice = prices.find(row => row.childSoItemId === item.soitemid).kitItemUnitPrice;
          const parent = kitProducts.find(row =>
            row.productid === item.id
            && row.kitproductid !== item.id);
          item.parentid = parent ? parent.kitProductId : null;
        }
      }
    });

    return sortedSalesOrderItems;
  },
  getSalesOrderItemStatus(product) {
    let status;
    switch (product.itemtype) {
      case 'Shipping':
        status = '';
        break;
      case 'Kit':
        status = 'Kit';
        break;
      default:
        status = product.status;
        break;
    }
    return status;
  },
  getAccurateNames(name, address) {
    let n = name;
    let s = address;
    const data = {
      company: '',
    };

    // if name is actually the company name
    if (s.split('').every(x => isNaN(x) || x === ' ')) {
      data.company = n;
      const splits = s.split('\n');
      n = splits[0].trim();
      splits.splice(0, 1);
      s = splits.join('\n').trim();
    }

    // split first and last name
    const names = n.split(' ');
    data.firstName = names[0].trim();
    names.splice(0, 1);
    data.lastName = names.join(' ').trim();

    // split street1 and street2
    const streets = s.split('\n');
    data.street1 = streets[0].trim();
    streets.splice(0, 1);
    data.street2 = streets.join('\n').trim();

    return data;
  },
  getFormattedShippingAddress(orderInfo) {
    const names = this.getAccurateNames(orderInfo.shiptoname, orderInfo.shiptoaddress);
    return {
      company: names.company,
      firstName: names.firstName,
      lastName: names.lastName,
      street1: names.street1,
      street2: names.street2,
      city: orderInfo.shiptocity,
      zip: orderInfo.shiptozip,
      phone_number: orderInfo.phone_number,
      region: orderInfo.shiptostate,
      readOnlyRegion: orderInfo.shiptostate,
      country: orderInfo.shiptocountry,
      readOnlyCountry: orderInfo.shiptocountry,
      carrier: orderInfo.carrier,
      shippingPriority: '',
    };
  },
  getFormattedBillingAddress(orderInfo) {
    const names = this.getAccurateNames(orderInfo.billtoname, orderInfo.billtoaddress);
    return {
      company: names.company,
      firstName: names.firstName,
      lastName: names.lastName,
      street1: names.street1,
      street2: names.street2,
      city: orderInfo.billtocity,
      zip: orderInfo.billtozip,
      phone_number: orderInfo.phone_number,
      region: orderInfo.billtostate,
      country: orderInfo.billtocountry,
    };
  },
  calculateTotalPrice(products) {
    let totalPrice = 0.0;
    products.forEach((product) => {
      totalPrice += parseFloat(product.unitPrice) * product.qtyToFulfill;
    });
    return totalPrice;
  },
  sortResults(soItems) {
      var childArray = []
      for (var i = soItems.length - 1; i >= 0; i--) {
        // the item is a kit item, remove it from the list for the time being
        if (soItems[i].kitParent !== undefined) {
          childArray.push(soItems[i]);
          soItems.splice(i, 1);
        }
      };

      // loop through child array and add kit items after their respective kits
      for (var i = 0; i < childArray.length; i++) {
        var item = childArray[i];
        var index = soItems.findIndex(parent => parent.product === item.kitParent);
        if (index == -1) {
          soItems.push(item);
          continue;
        }
          soItems.splice(index + 1, 0, item);
      };

      // remove subkits
      for (var i = soItems.length - 1; i>= 0; i--) {
        var item = soItems[i];
        if (soItems[i].kitParent !== undefined && soItems[i].type === 'Kit') {
          soItems.splice(i, 1);
        }
      };
     return soItems;
  },
};



// WEBPACK FOOTER //
// /src/helpers/services/fishbowl.js